import { 
  createPlugin, 
  createApiFactory, 
  fetchApiRef,
  discoveryApiRef
} from '@backstage/core-plugin-api';
import { simpleGCPSubnetSelectorApiRef, SimpleGCPSubnetSelectorClient } from './simpleApi';

export const gcpSubnetSelectorPlugin = createPlugin({
  id: 'gcp-subnet-selector',
  apis: [
    createApiFactory({
      api: simpleGCPSubnetSelectorApiRef,
      deps: { 
        fetchApi: fetchApiRef,
        discoveryApi: discoveryApiRef
      },
      factory: ({ fetchApi, discoveryApi }) => new SimpleGCPSubnetSelectorClient(fetchApi, discoveryApi),
    }),
  ],
});